// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"005ad3ad","488":"a8cce558","977":"ead67f82"}[chunkId] + ".chunk.js";
};